import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const GrassesWild: Portfolio = {path: "grasses-wild", name: "Grasses Wild", pageStyle: PageStyle.Tan, pieces: [
        {image: "grasses-wild-01.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 1", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-wild-02.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 2", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-wild-03.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 3", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-wild-04.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 4", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-wild-06.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 6", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-wild-07.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 7", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-wild-08.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 8", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-wild-10.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 10", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-wild-12.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 12", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-wild-13.jpg", thumbAlt: "Grasses Wild", title: "Grasses Wild 13", size: "10 \u00d7 40\nrelief monotype\n2015", pixelWidth: 175, pixelHeight: 705},
    ],
    piecesColumns: 9,
    piecesTallMode: true,
    statementTitle: "Grasses Wild",
    statement: {
        leftColumn: [
            <>"The rain-drenched stone that leads the way" <i>Santoka</i></>,
            "The natural world and its complexities are the foundation of my art practice. I am mystified, inspired, " +
            "and humbled by the intricacies of the systems that inform and embody human existence and provide the " +
            "context in which we live.",
            "The creatures and plants on earth in relationship with humans and their coevolution is a moving, " +
            "breathing entity. It is a wonder to explore the tender and energetic meeting place where the two " +
            "intersect. There is a language here in this confluence…a dynamic cry or a soothing whisper…that moves " +
            "us forward, together. I am inspired by this relationship and its beauty, mystery, and tragedy, but most " +
            "of all its potential.",
            "Remembering is fundamental to my work. I commemorate my own losses within the ongoing transitions of the " +
            "natural world."
        ],
        rightColumn: [

        ]
    }
};

export default GrassesWild;